import React, {Component} from 'react';
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

import classes from './AvailableLinksInput.module.css';

class AvailableLinksInput extends Component  {
    state = {
        game_available_links: []
    };

    componentDidMount() {
        this.setState({game_available_links: this.props.availableLinks});
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps !== this.props) {
            this.setState({game_available_links: this.props.availableLinks});
        }
    }

    addGameAvailableLink = () => {
        this.setState(
            {game_available_links: [
                    ...this.state.game_available_links,
                    {
                        game_available_link_id: null,
                        game_available_link: "",
                        game_available_link_notes: "",
                        game_available_link_source: ""
                    }]
            });
    };

    arraySearch(arr,val) {
        for (let i = 0; i < arr.length; i++) {
            if (arr[i].value === val)
                return i;
        }
        return -1;
    }

    render() {
        let availableLinksInputElement = null;

        if (this.state.game_available_links && this.state.game_available_links.length) {
            let available_links_index = 0;
            let game_available_links = [...this.state.game_available_links];
            availableLinksInputElement = (
                <>
                    <dd className="col-sm-9">
                        {game_available_links.map(available_link => {
                            let available_links_index_local = available_links_index;
                            // const game_available_link_id = game_available_links[available_links_index_local].game_available_link_id;
                            //const game_available_link_text = available_link.game_available_link;

                            const return_jsx = (
                                <div className={classes.availableLinksBlock} key={available_links_index_local}>

                                    <div className={classes.availableLinkField}>
                                        <Form.Control
                                            type="text"
                                            placeholder="Where is the game available through. (Steam, Playstation Store, etc.)"
                                            value={available_link.game_available_link_source}
                                            onChange={(event) => {
                                                let game_available_links_local = [...game_available_links];
                                                game_available_links_local[available_links_index_local] = {
                                                    game_available_link_id: game_available_links_local[available_links_index_local].game_available_link_id,
                                                    game_available_link: game_available_links_local[available_links_index_local].game_available_link,
                                                    game_available_link_notes: game_available_links_local[available_links_index_local].game_available_link_notes,
                                                    game_available_link_source: event.target.value
                                                };
                                                this.setState({game_available_links: game_available_links_local});
                                                this.props.availableLinksUpdate(game_available_links_local);
                                            }}/>
                                    </div>
                                    <div className={classes.deleteAvailableLinks}>
                                        <Button className={classes.deleteAvailableLinksButton} size="sm" variant={"outline-danger"} onClick={() => {
                                            let filtered_array = game_available_links.filter((value,index,array) => {
                                                return index !== (available_links_index_local)
                                            });

                                            this.setState({game_available_links: filtered_array});
                                            this.props.availableLinksUpdate(filtered_array);
                                        }}>X</Button>
                                    </div>

                                    <div className={classes.gameAvailableLink}>
                                        <Form.Control
                                            as="textarea"
                                            rows="1"
                                            placeholder="Input the link here."
                                            value={available_link.game_available_link}
                                            onChange={(event) => {
                                                let game_available_links_local = [...game_available_links];
                                                game_available_links_local[available_links_index_local] = {
                                                    game_available_link_id: game_available_links_local[available_links_index_local].game_available_link_id,
                                                    game_available_link: event.target.value,
                                                    game_available_link_notes: game_available_links_local[available_links_index_local].game_available_link_notes,
                                                    game_available_link_source: game_available_links_local[available_links_index_local].game_available_link_source
                                                };
                                                this.setState({game_available_links: game_available_links_local});
                                                this.props.availableLinksUpdate(game_available_links_local);
                                            }}/>
                                    </div>

                                    <div className={classes.gameAvailableLink}>
                                        <Form.Control
                                            as="textarea"
                                            rows="1"
                                            placeholder="Notes on the game source."
                                            value={available_link.game_available_link_notes}
                                            onChange={(event) => {
                                                let game_available_links_local = [...game_available_links];
                                                game_available_links_local[available_links_index_local] = {
                                                    game_available_link_id: game_available_links_local[available_links_index_local].game_available_link_id,
                                                    game_available_link: game_available_links_local[available_links_index_local].game_available_link,
                                                    game_available_link_notes: event.target.value,
                                                    game_available_link_source: game_available_links_local[available_links_index_local].game_available_link_source
                                                };
                                                this.setState({game_available_links: game_available_links_local});
                                                this.props.availableLinksUpdate(game_available_links_local);
                                            }}/>
                                    </div>




                                </div>
                            );
                            available_links_index++;

                            return return_jsx;
                        })}
                    </dd>
                    <dt className="col-sm-3"> </dt>
                </>
            );
        }

        return (
            <dl className="row">
                <dt className="col-sm-3"><label>Game Available Through:</label></dt>
                {availableLinksInputElement}
                <dd className="col-sm-9"><Button className="col-sm-12" variant="outline-primary" onClick={this.addGameAvailableLink}>Add Available Link</Button></dd>
            </dl>
        );
    }
}

export default AvailableLinksInput;